import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filtering"
export default class extends Controller {
  static targets = ['icon', 'body', 'filters']

  connect() {
    this.filtersTarget.innerHTML = ''
    this.element.querySelectorAll('[id$=_search] .form-control, [id$=_search] .form-select').forEach(elem => {
      const isSelect = elem.tagName === 'SELECT';
      const hasValue = isSelect ? elem.selectedOptions.length > 0 : !!elem.value;

      if (hasValue && elem.type != "hidden") {
        const field_id = elem.getAttribute('id');

        const label_field = this.element.querySelector(`label[for="${field_id}"]`);
        const label_text = label_field?.textContent || elem.getAttribute('placeholder') || elem.dataset.label;

        let ransackValue = "";
        if (isSelect) {
          ransackValue = Array.from(elem.selectedOptions)
            .filter(opt => opt.value !== "")
            .map(opt => opt.innerText.trim())
            .join(' ou ');
        } else {
          ransackValue = elem.value;
        }

        if (!ransackValue) return;

        const result_label = `${label_text}: ${ransackValue}`
        let filter = `<span class="js-filter badge badge bg-secondary-subtle text-secondary-emphasis">${result_label}`;
        if (!['q_s', 'q_discarded_at_not_null'].includes(elem.getAttribute('id'))) {
          filter += `&nbsp;<i class="fa fa-times js-delete-filter"
            data-action="click->filtering#remove_field"
            data-filtering-field-id-param="#${field_id}"></i>`
        }
        filter += '</span>'
        this.filtersTarget.insertAdjacentHTML('beforeend', filter);
      }
    })
  }

  toggle() {
    if (this.iconTarget.classList.contains('fa-angle-down')) {
      this.iconTarget.classList.remove('fa-angle-down')
      this.iconTarget.classList.add('fa-angle-right')
      this.bodyTarget.style.display = "none"
    } else {
      this.iconTarget.classList.remove('fa-angle-right')
      this.iconTarget.classList.add('fa-angle-down')
      this.bodyTarget.style.display = "block"
    }
  }

  remove_field({ params }) {
    const field = this.element.querySelector(params.fieldId);
    if (field.tagName === 'SELECT') {
      Array.from(field.options).forEach(option => option.selected = false);
    } else {
      field.value = '';
    }

    field.dispatchEvent(new Event('change'));
    this.element.querySelector('button[type=submit]').click();
  }
}
